import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import {
    addToChainBefore,
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { sendAddToCartEvent } from "@insite/client-framework/OdpEvents/UpdateCartEvents";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { AddCartLinesApiParameter, addLineCollection } from "@insite/client-framework/Services/CartService";
import { DispatchBeginUpdatingCart, chain } from "@insite/client-framework/Store/Data/Carts/Handlers/AddCartLines";
import { CartLineCollectionModel, CartLineModel } from "@insite/client-framework/Types/ApiModels";
import setShowRequisitionCartDisclaimer from "@tKgpco/Handlers/RequistionCart/Handlers/showRequisitionCartDisclaimer";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";

type Parameter = {
    productInfos: ProductInfo[];
} & HasOnSuccess<CartLineCollectionModel>;

type Props = {
    apiParameter: AddCartLinesApiParameter;
    apiResult: CartLineCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginUpdatingCartCustom: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;

    if (state.KGPState.RequistionCartStore.isRequistionCartPresent) {
        props.dispatch(setShowRequisitionCartDisclaimer({ showDisclaimerForRequistionCart: true }));
        return false;
    }
};

addToChainBefore(chain, DispatchBeginUpdatingCart, DispatchBeginUpdatingCartCustom);
